// Simple event bus for cross-component communication
// Usage: eventBus.on('event', handler); eventBus.emit('event', payload);

type Handler = (payload?: any) => void;

class EventBus {
  private events: Record<string, Handler[]> = {};

  on(event: string, handler: Handler) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(handler);
    return () => this.off(event, handler); // Return unsubscribe function
  }

  off(event: string, handler: Handler) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(h => h !== handler);
  }

  emit(event: string, payload?: any) {
    if (!this.events[event]) return;
    this.events[event].forEach(handler => handler(payload));
  }
}

const eventBus = new EventBus();
export default eventBus;
